import {
    AdminUserView,
    UnauthorizedView
} from '../views';

export const PrivateRoutes = [
  {
    path: "/usuarios",
    component: AdminUserView,
    title: "Usuarios",
    exact: true,
    showMenu: true
  },
  {
    path: "/unauthorized",
    component: UnauthorizedView,
    title: "Unauthorized",
    exact: true,
    showMenu: false
  }
];
